/**
 * Un écran poussé de l'espace tuteur, monté par le pont (`tutorSpaceBridge`) : sans l'en-tête de la
 * pile (une page du design system porte le sien), dans le thème du tuteur, posé avant sa peinture
 * même ouvert à froid (`ThemeSettledScreen`, le même que chez l'élève).
 *
 * Hors live, l'écran qui a le focus dit lui-même ses échecs réseau : les boîtes de l'ancien kit se taisent
 * (`useOwnNetworkFailuresWhileFocused`). En live, la salle répond seule : rien ne change pour elle.
 *
 * Chargé par le pont à la première route allumée seulement : éteint, Unistyles n'est pas lu.
 */
import React, { useLayoutEffect } from "react"
import { useNavigation } from "@react-navigation/native"
import { useSelector } from "react-redux"

import { useOwnNetworkFailuresWhileFocused } from "../../hooks/useOwnNetworkFailuresWhileFocused"
import { useTutorThemeScope } from "../../hooks/useTutorThemeScope"
import { ThemeSettledScreen } from "../student/ThemeSettledScreen"
import { selectTutorSpaceContext } from "./tutorSpaceBridge"
import { type TutorSpaceScreen, type TutorSpaceScreenProps } from "./tutorSpaceRouteTypes"

type Props = TutorSpaceScreenProps & { Screen: TutorSpaceScreen }

export function TutorSpaceScreenHost(props: Props) {
    const { Screen, route } = props
    const navigation = useNavigation() as unknown as { setOptions: (options: object) => void }
    useTutorThemeScope()
    const inLive = useSelector((state: unknown) => selectTutorSpaceContext(state).inLive)
    useOwnNetworkFailuresWhileFocused(!inLive)

    useLayoutEffect(() => {
        navigation.setOptions({ headerShown: false })
    }, [navigation])

    return <ThemeSettledScreen Screen={Screen} route={route} />
}
